export default ({
  addressByRepository,
  maps,
  data
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      actions,
      dispatch,
      getState,
			extraData
    } = payload

    try {
      const address = await addressByRepository.fetchAddressByCEP({
        data,
				extraData,
        actions,
        maps,
        dispatch,
        getState
      })

      await onSuccess({ address })
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
